var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTw = function SvgTw(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 35 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#tw_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FE0000",
    d: "M32.016 1H2v20h30.016V1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000095",
    d: "M17.007 1H2v10.001h15.007V1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m7.923 4.575-1.67-.45L7.477 5.35c.092-.286.244-.55.445-.774ZM8.848 3.977 7.625 2.754l.45 1.67c.224-.201.487-.353.773-.447ZM11.376 2.754l-1.223 1.223c.286.093.55.245.773.447l.45-1.67ZM9.948 3.92 9.5 2.235l-.445 1.687c.294-.064.598-.064.892 0ZM13.252 6l-1.687-.446a2.112 2.112 0 0 1 0 .894L13.252 6ZM11.526 5.349l1.226-1.223-1.688.45c.208.22.366.485.462.773ZM10.153 8.022l1.223 1.24-.45-1.687a2.1 2.1 0 0 1-.773.447ZM9.056 8.078l.445 1.687.447-1.687a2.102 2.102 0 0 1-.892 0ZM7.374 6c0-.15.016-.3.048-.446L5.75 6l1.673.447A2.152 2.152 0 0 1 7.374 6ZM11.078 7.426l1.688.45-1.226-1.223a2.128 2.128 0 0 1-.462.773ZM7.478 6.653 6.252 7.876l1.67-.45a2.164 2.164 0 0 1-.444-.773ZM7.625 9.261l1.223-1.225a2.124 2.124 0 0 1-.762-.461L7.625 9.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.492 4.126a1.877 1.877 0 0 0-1.326 3.2 1.876 1.876 0 0 0 2.653-2.651 1.876 1.876 0 0 0-1.327-.55Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "tw_svg__a",
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
};
export default SvgTw;